import { Grid, Typography } from '@material-ui/core'

import moment from 'moment/moment'

import { GRAY_COLORS } from 'asterX-UI'
import { a11yProps, Tab, TabPanel, Tabs } from 'asterX-UI/Tabs'

import { ropTabsList } from './constants'
import { useHomeStoreRop } from 'context/HomeStore/Rop'

export const RopTabs = () => {
  const {
    homeStore: { ropTab },
    homeStoreFunc: { setRopTab }
  } = useHomeStoreRop()

  return (
    <Grid container spacing={8}>
      <Grid item xs={12}>
        <Grid
          container
          alignItems="center"
          justifyContent="space-between"
          style={{ borderBottom: `1px solid ${GRAY_COLORS[200]}` }}
        >
          <Grid item>
            <Tabs
              value={ropTab}
              onChange={(_, newValue) => setRopTab(newValue)}
            >
              {ropTabsList.map((item, i) => {
                const Icon = item?.icon || null

                return (
                  <Tab
                    {...a11yProps(i)}
                    key={`rop-tab-${i}`}
                    label={item?.label || ''}
                    icon={Icon && <Icon />}
                    value={i}
                  />
                )
              })}
            </Tabs>
          </Grid>

          <Grid item>
            <Typography
              variant="subtitle2"
              style={{ color: GRAY_COLORS[500], textTransform: 'capitalize' }}
            >
              {moment().format('dddd, D MMMM')}
            </Typography>
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs={12}>
        {ropTabsList.map((item, i) => {
          const Component = item.component

          return (
            <TabPanel key={`rop_tab_panel_${i}`} index={i} value={ropTab}>
              <Component />
            </TabPanel>
          )
        })}
      </Grid>
    </Grid>
  )
}
